import React, {
    ReactElement, useEffect, useState,
} from "react";
import useRouting, { Paths } from "../../contexts/Routing";
import { LoadingIcon } from "../loading/Loading";
import Styles from "./SearchBar.module.css";

const TIME_INTERVAL = 500;

interface SearchProps {
    onChange: (newString: string) => void;
    className: string;
    isLoading?: boolean;
}

export default function SearchBar({ onChange, className, isLoading }: SearchProps): ReactElement {
    const { getSearchParams, historyPushSearch } = useRouting();
    const { search } = getSearchParams(Paths.ANSWERS_GET);
    const [searchString, setSearchString] = useState<string>(search ?? "");
    const [timer, setTimer] = useState<ReturnType<typeof setTimeout>>();

    useEffect(() => {
        onChange(searchString);
        if (searchString) {
            historyPushSearch({ search: searchString as string });
        } else {
            historyPushSearch({});
        }
    }, [searchString]);

    useEffect(() => {
        setSearchString(search);
    }, [search]);

    async function handleSubmit(evt: React.FormEvent<HTMLFormElement>): Promise<void> {
        evt.preventDefault();
        setSearchString(searchString);
    }

    function handleChange(evt: React.FormEvent<HTMLInputElement>): void {
        const { value } = evt.currentTarget;

        if (timer) {
            clearTimeout(timer);
        }
        if (value === "") {
            setSearchString(value);
        } else {
            setTimer(setTimeout(() => {
                setSearchString(value);
            }, TIME_INTERVAL));
        }
    }

    return (
        <form onSubmit={handleSubmit} className={`${Styles["search-bar"]} my-4 d-flex`}>
            <input
                onChange={handleChange}
                type="search"
                placeholder="Search..."
                defaultValue={searchString}
                data-test="search-bar"
                className={className}
                aria-label="Search for answers"
            />
            {isLoading && (
                <LoadingIcon className={Styles["loading-icon"]} />
            )}

        </form>
    );
}

SearchBar.defaultProps = {
    isLoading: false,
};
